module.exports = __webpack_public_path__ + "static/img/function-box-img1.88ce563.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedPortal/function-box-img1.png
// module id = SHzR
// module chunks = 0